import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TrackingService } from '../tracking/tracking.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreConfigService } from '../core/core.service';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Params } from '@fortawesome/fontawesome-svg-core';
import { MatChipInputEvent } from '@angular/material/chips';
import { interval } from 'rxjs';

@Component({
  selector: 'kett-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
})
export class SearchFormComponent implements OnInit, AfterViewInit {
  @ViewChild('textarea_tracking') textarea_tracking: ElementRef;
  @ViewChild('input_tracking') input_tracking: ElementRef;
  @ViewChild('ta') ta: ElementRef;
  ListTracking: string[] = [];
  FocusInput = false;
  constructor(
    private _FormBuilder: FormBuilder,
    private _TrackingService: TrackingService,
    private _Router: Router,
    private _TranslateService: TranslateService,
    private _CoreConfigService: CoreConfigService,
    private _ActivatedRoute: ActivatedRoute
  ) {
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  SearchForm: FormGroup;

  ngAfterViewInit() {
    setTimeout(() => {
      this.autogrow();
    }, 500);
  }

  ngOnInit(): void {
    this.ResetForm();

    this._ActivatedRoute.queryParams.subscribe((queryParams: Params) => {
      if (queryParams && queryParams['track']) {
        //need decode
        if (this._TrackingService.CheckDecrypt(queryParams['track'])) {
          let decode = this._TrackingService.DecryptOldTrack(
            queryParams['track']
          );
          if (decode) {
            this.ListTracking = [decode];
            this.SearchForm.get('tracking').setValue(decode);
            this.SplitTracking();
          } else {
            this._Router.navigate([''], {
              skipLocationChange: true,
            });
          }
        } else {
          this.SearchForm.get('tracking').setValue(queryParams['track'].trim());
          this.SplitTracking();
        }
      }
    });
  }

  SwtichFocus(OnInput: boolean) {
    if (OnInput) {
      this.FocusInput = true;
      setTimeout(() => {
        this.textarea_tracking.nativeElement.focus();
      }, 100);
    } else {
      let is_changed = this.ListTracking.join(',');
      let current_inpunt = this.SearchForm.get('tracking').value;
      if (current_inpunt && is_changed != current_inpunt) {
        this.SplitTracking();
        this.SearchForm.get('tracking').setValue(this.ListTracking.join(','));
        this.autogrow();
      }

      this.FocusInput = false;
    }
  }

  autogrow() {
    this.ta.nativeElement.style.overflow = 'hidden';
    this.ta.nativeElement.style.height = 'auto';
    this.ta.nativeElement.style.height =
      this.ta.nativeElement.scrollHeight == 0
        ? 40
        : this.ta.nativeElement.scrollHeight + 'px';
  }

  

  autoCommaTextSeatch(ev: ClipboardEvent) {

    const input = ev.clipboardData.getData('tracking');
    const words = input.split(" ");
    const newText = words.join(",");
    const currentText = this.SearchForm.get('tracking').value;
    const finalText = currentText.length > 0 ? currentText + "," + newText : newText;
    this.SearchForm.get('tracking').setValue(finalText);
  }

  addConChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      let tmp_value = value
        .split(' ')
        .filter((e) => e)
        .join('$')
        .split(',')
        .filter((e) => e)
        .join('$')
        .split('\n')
        .filter((e) => e)
        .join('$')
        .split('$')
        .filter((e) => e)
        .map((d) => d.trim());

      if (tmp_value) {
        let idx_old = this.ListTracking.findIndex(
          (s) => s.toUpperCase() == value.toUpperCase()
        );
        if (idx_old >= 0) {
          this.ListTracking.splice(idx_old, 1);
        }
        this.ListTracking = this.ListTracking.concat(tmp_value);
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  addChip(value: string): void {
    if ((value || '').trim()) {
      let tmp_value = value
        .split(' ')
        .filter((e) => e)
        .join('$')
        .split(',')
        .filter((e) => e)
        .join('$')
        .split('\n')
        .filter((e) => e)
        .join('$')
        .split('$')
        .filter((e) => e)
        .map((d) => d.trim());

      if (tmp_value) {
        let idx_old = this.ListTracking.findIndex(
          (s) => s.toUpperCase() == value.toUpperCase()
        );
        if (idx_old >= 0) {
          this.ListTracking.splice(idx_old, 1);
        }
        this.ListTracking = this.ListTracking.concat(tmp_value);
      }
    }

    // Reset the input value
    if (value) {
      this.SearchForm.get('tracking').setValue('');
    }
  }

  SplitTracking() {
    const value = this.SearchForm.get('tracking').value;
    this.ListTracking = [];
    if ((value || '').trim()) {
      let tmp_value: string[] = value
        .split(' ')
        .filter((e) => e)
        .join('$')
        .split(',')
        .filter((e) => e)
        .join('$')
        .split('\n')
        .filter((e) => e)
        .join('$')
        .split('$')
        .filter((e) => e)
        .map((d) => d.trim());

      this.ListTracking = tmp_value.filter((v, i, a) => a.indexOf(v) == i);
    }
  }

  removeChip(val: string): void {
    const index = this.ListTracking.indexOf(val);
    if (index >= 0) {
      this.ListTracking.splice(index, 1);
    }
  }

  ResetForm() {
    this._TrackingService.ResetListTracking();
    this.SearchForm = this._FormBuilder.group({
      tracking: '',
    });
  }

  formattracking(ev) {}

  SearchData() {
    this.SplitTracking();
    if (
      this._ActivatedRoute.snapshot.queryParams['track'] &&
      JSON.stringify(this._ActivatedRoute.snapshot.queryParams['track']) ==
        JSON.stringify(this.ListTracking.join(','))
    ) {
      this._Router.navigate([''], {
        skipLocationChange: true,
      });
      setTimeout(() => {
        this._Router.navigate([''], {
          queryParams:
            this.ListTracking.length > 0
              ? {
                  track: this._TrackingService.EncryptOldTrack(
                    this.ListTracking
                  ),
                }
              : {},
        });
      }, 10);
    } else {
      this._Router.navigate([''], {
        queryParams:
          this.ListTracking.length > 0
            ? {
                track: this._TrackingService.EncryptOldTrack(this.ListTracking),
              }
            : {},
      });
    }

  }
}
